import { Link } from 'react-router-dom';
import { getHotHosts } from '@/mocks/hosts';
import type { JSX } from 'react';

interface Host {
  id: number;
  name: string;
  avatar: string;
  cover: string;
  category: string;
  tags: string[];
  viewers: string;
  followers: string;
  description: string;
  isOnline: boolean;
  rating: number;
}

export default function HotHostsSection(): JSX.Element {
  const hotHosts = getHotHosts(6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门美女直播排行
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            精选当月最受欢迎的高颜值主播，实时在线互动，精彩不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {hotHosts.map((host: Host) => (
            <div
              key={host.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={host.cover}
                  alt={host.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {host.isOnline && (
                  <span className="absolute top-3 left-3 flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
                    直播中
                  </span>
                )}
                <span className="absolute top-3 right-3 flex items-center gap-1 px-2 py-0.5 rounded-md bg-black/50 text-white text-xs backdrop-blur-sm">
                  <i className="ri-eye-line text-[10px]"></i>
                  {host.viewers}
                </span>
              </div>

              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={host.avatar}
                    alt={host.name}
                    className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover border-2 border-background-100"
                  />
                  <div>
                    <h3 className="font-heading font-semibold text-foreground-950 text-base">
                      {host.name}
                    </h3>
                    <p className="text-foreground-500 text-xs">{host.category} · {host.followers}粉丝</p>
                  </div>
                  <span className="ml-auto flex items-center gap-0.5 text-accent-500 text-sm font-medium">
                    <i className="ri-star-fill text-xs"></i>
                    {host.rating}
                  </span>
                </div>

                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2 mb-3">
                  {host.description}
                </p>

                <div className="flex flex-wrap items-center gap-1.5">
                  {host.tags.map((tag: string) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-200 text-primary-600 hover:bg-primary-50 font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部主播
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}